import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=655af2e0&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=ts&"
export * from "./ProductDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=655af2e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655af2e0",
  null
  
)

export default component.exports